import React from "react";
import { Link } from "react-router-dom";
import AuthShell from "./AuthShell";

const Success = () => {
  return (
    <AuthShell
      title="Success"
      heading="Thank you for submitting form"
      subheading="You can now sign in with your new password."
      brandHeadline="Back to work in a couple of minutes."
      brandSubcopy="Your projects, schedules and daily progress are exactly where you left them."
    >
      <Link className="pxauth-btn" to={`${process.env.PUBLIC_URL}/`}>
        Back to login
      </Link>
    </AuthShell>
  );
};
export default Success;
